export default "__VITE_ASSET__0042bea9__"